import React from 'react'
import { TranslateContext } from '../TranslateContext'
import './itemTab.css'
export default function dependencies() {
  const translate = React.useContext(TranslateContext).translate
  return (
    <div>
      <form className='depen_container'>
        <div className='depen_mainLabel'>
          <label>{translate("DEPENDENCIES", {ns:["default", "lineItem"]})}</label>
        </div>
        <div className='depen_Row'>
          <div className='depen_Col'>
            <input type='checkbox' className='depen_check' />
            <span className='depen_label'>{translate("RELATIONSHIP", {ns:["default", "lineItem"]})}</span>
          </div>
          <div className='depen_Col'>
            <input type='checkbox' className='depen_check' />
            <span className='depen_label'>{translate("RESTRICTION", {ns:["default", "lineItem"]})}</span>
          </div>
          <div className='depen_Col'>
            <input type='checkbox' className='depen_check' />
            <span className='depen_label'>{translate("CONDITIONAL", {ns:["default", "lineItem"]})}</span>
          </div>
          <div className='depen_Col'>
            <input type='checkbox' className='depen_check' />
            <span className='depen_label'>{translate("ARRANGEMENT", {ns:["default", "lineItem"]})}</span>
          </div>
        </div>
      </form>
    </div>
  )
}
